"use strict";

angular.module("models").service("DocumentRequestsService", ["ApiService", function (ApiService) {
  var that = this;

  var params = {
    name: "DocumentRequests",
    attributesForCache: ["name"],
    formatName: function formatName(element) {
      return element.name ? element.name : "???";
    },
    defaultOrder: { creationDate: -1 }
  };

  angular.extend(that, ApiService.getModelBis(params));
}]);